import { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import {
  getMemberProgress,
  clearProgress,
} from "../../store/ducks/dailyCheckIn/actions";
import MemberProgress from "./MemberProgress";
import Swal from "sweetalert2";

class DailyCheckIn extends Component {
  componentDidUpdate(prevProps) {
    if (
      prevProps.clearProgressResult !== this.props.clearProgressResult &&
      this.props.clearProgressResult.responseCode === 200
    ) {
      const { t } = this.props;

      Swal.fire({
        icon: "success",
        title: t("global.success"),
        html: this.props.clearProgressResult.message[0],
        showConfirmButton: true,
        confirmButtonText: t("global.ok"),
      }).then(() => {
        this.props.getMemberProgress();
      });
    }
  }

  render() {
    return (
      <div
        className="position-fixed top-50 start-50 translate-middle"
        style={{ zIndex: 999 }}
      >
        <MemberProgress />
        <div className="d-flex justify-content-end" style={{ gap: "10px" }}>
          <button
            className="btn btn-primary"
            onClick={() => this.props.clearProgress()}
          >
            Clear Progress
          </button>
          <button
            className="btn btn-primary"
            onClick={() => this.props.onCloseMemberProgress()} // passed from Home.js
          >
            Close
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (reduxState) => {
  return {
    clearProgressResult: reduxState.dailyCheckIn?.clearProgress?.data|| {},
  };
};

const mapDispatchToProps = {
  clearProgress,
  getMemberProgress,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces("translation")(DailyCheckIn));
